import React from 'react';
import { AnsweringSubscriptionTag, BuildJsonType } from '@bb/domain/dist/types';
import { OrgDoc } from '@bb/domain/dist/schemas';
import {
  StyledBrokerageTileContainer,
  StyledOverlay,
  StyledLogo,
} from './StyledComponents';
import {
  CrossOrgAnsweringContext,
  CrossOrgAnsweringContextProvider,
} from '../../../../contexts';

export interface BrokerageTileProps {
  org: BuildJsonType<OrgDoc & { subscriptionTag?: AnsweringSubscriptionTag }>;
}

const BrokerageTile: React.FC<BrokerageTileProps> = ({ org }) => {
  const assume = (assumedOrgId: string) => {
    const chatSessionStorageKeys = [
      'messageDrafts',
      'messageDraftsForNewConvo',
      'chatInstances',
      'activeChatInstance',
      'newConvoSelections',
      'assumedChatInstances',
      'assumedBrokerageId',
    ];

    chatSessionStorageKeys.forEach(key => sessionStorage.removeItem(key));
    window.location.pathname = `/answering/assume/${assumedOrgId}`;
  };

  return (
    <CrossOrgAnsweringContextProvider>
      <CrossOrgAnsweringContext.Consumer>
        {crossOrgAnsweringContext => (
          <StyledBrokerageTileContainer>
            <StyledOverlay
              onClick={crossOrgAnsweringContext.answeringConfirm(
                { type: 'brokerage', subscriptionTag: org.subscriptionTag },
                () => assume(org.id),
              )}
            >
              Assume
            </StyledOverlay>
            <h5>{org.name.split(', ')[0]}</h5>
            <StyledLogo src={org.logoUrl} />
          </StyledBrokerageTileContainer>
        )}
      </CrossOrgAnsweringContext.Consumer>
    </CrossOrgAnsweringContextProvider>
  );
};

export default BrokerageTile;
